import {Component, OnInit} from '@angular/core';
import {MatDialogRef} from "@angular/material/dialog";

@Component({
  selector: 'app-usage-hints-modal',
  templateUrl: './usage-hints-modal.component.html',
  styleUrls: ['./usage-hints-modal.component.scss']
})
export class UsageHintsModalComponent implements OnInit {

  constructor(private dialogRef: MatDialogRef<UsageHintsModalComponent>) {

  }

  ngOnInit(): void {
  }

  closeDialog() {
    this.dialogRef.close();
  }

}
